<template>
<div class="modal fade" id="MlListpopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="max-width:780px;position:fixed;margin-left:-390px;left:50%;" id="MlListpopupContent">
       <div class="modal-content" style="max-height:85vh; overflow-y:auto; min-height:0;">
          <div  class="modal-header">
             <h5 class="modal-title text-center pull-left w-100 d-block mt-4 pb-0 mb-2 mb-0">Machine Learning</h5>
             <button type="button" data-dismiss="modal" class="close d-close"><i  class="material-icons">close</i></button>
          </div>
          <div class="btn-sticky-hold" id="sticky" style="top:calc(100% - 50px);">
           <div class="row">
              <div class="col-12 text-right sticky-details">
                <button @click="SaveMLSummary" type="button" class="primary-btn pull-right">Update Summary</button>
                <button @click="ClearMLPopUp" type="button" class="secondary-btn mr-3 pull-right">Clear</button>
              </div>
            </div>
         </div>
           <div  class="modal-body mt-0 pt-0 pb-5">             

            <!---->
            <div  class="col-12 pb-5">
              <div class="row">
                <div class="col-12">
                   <p class="text-info">Notes: Selected items will be added in to Doctor summary/notes section</p>
                </div>
                <div class="col-6 pb-3">
                  <p class="mb-2 font-weight-500">Symptoms</p>
                  <multiselect
                                  v-model="selected_symptoms_list"
                                  :options="symptoms_list"
                                  multiple
                                  :taggable="true"
                                  @tag="addKeyword($event,'symptom')"
                                  tag-placeholder="Add this as new symptom"
                                  @remove="removeKeyword($event,'symptom')"
                                  placeholder="Select Symptoms"
                                  :close-on-select="false"
                                  @input="FilterBySelectedItem($event,'symptoms')"
                                >
                                </multiselect>
                </div>
                <div class="col-6 pb-3" id="Comorbidityhold"><p class="mb-2 font-weight-500">Comorbidity</p>
                 <multiselect
                                  v-model="selected_comorbidities_list"
                                  :options="comorbidities_list"
                                  multiple
                                  :taggable="true"
                                  @tag="addKeyword($event,'comorbidity')"
                                  tag-placeholder="Add this as new comorbidity"
                                  @remove="removeKeyword($event,'comorbidity')"
                                  placeholder="Select Comorbidity"
                                  :close-on-select="false"
                                  @input="FilterBySelectedItem($event, 'comorbidity')"
                                >
                                </multiselect></div>
                <div class="col-6 pb-3" id="Diagnosishold"><p class="mb-2 font-weight-500">Diagnosis</p>
                <multiselect
                                  v-model="selected_diagnosis_list"
                                  :options="diagnosis_list"
                                  multiple
                                  :taggable="true"
                                  @tag="addKeyword($event,'diagnosis')"
                                  tag-placeholder="Add this as new diagnosis"
                                  @remove="removeKeyword($event,'diagnosis')"
                                  placeholder="Select Diagnosis"
                                  :close-on-select="false"
                                  @input="FilterBySelectedItem($event, 'diagnosis')"
                                >
                                </multiselect></div>
                <div class="col-6 pb-3" id="Radiologyhold"><p class="mb-2 font-weight-500">Radiology</p>
                 <multiselect
                                  v-model="selected_radiology_list"
                                  :options="radiology_list"
                                  multiple
                                  :taggable="true"
                                  @tag="addKeyword($event,'radiology')"
                                  tag-placeholder="Add this as new radiology"
                                  placeholder="Select Radiology"
                                  @remove="removeKeyword($event,'radiology')"
                                  :close-on-select="false"
                                  @input="FilterBySelectedItem($event, 'radiology')"
                                >
                                </multiselect></div>
                <div class="col-6 pb-3" id="Investigationshold"><p class="mb-2 font-weight-500">Investigations</p>
                <multiselect
                                  v-model="selected_investigation_list"
                                  :options="investigation_list"
                                  multiple
                                  :taggable="true"
                                  @tag="addKeyword($event,'investigation')"
                                  @remove="removeKeyword($event,'investigation')"
                                  tag-placeholder="Add this as new investigation"
                                  placeholder="Select Investigation"
                                  :close-on-select="false"
                                  @input="FilterBySelectedItem($event, 'investigation')"
                                >
                                </multiselect></div>
                                <div class="col-6 pb-3" id="SupportiveTreatmenthold"><p class="mb-2 font-weight-500">Supportive Treatment</p>
                 <multiselect
                                  v-model="selected_supportive_treatment_list"
                                  :options="supportive_treatment_list"
                                  multiple
                                  :taggable="true"
                                  @tag="addKeyword($event,'supportive_treatment')"
                                  tag-placeholder="Add this as new supportive treatment"
                                  @remove="removeKeyword($event,'supportive_treatment')"
                                  placeholder="Select Supportive Treatment"
                                  :close-on-select="false"
                                  @input="FilterBySelectedItem($event, 'supportive_treatment')"
                                >
                                </multiselect></div>
                <div class="col-10 pb-3" id="Prescriptionhold"><p class="mb-2 font-weight-500">Prescription</p>
                <multiselect
                                  v-model="selected_prescription_list"
                                  :options="prescription_list"
                                  multiple
                                  :taggable="true"
                                  @tag="addKeyword($event,'prescription')"
                                  @remove="removeKeyword($event,'prescription')"
                                  tag-placeholder="Add this as new prescription"
                                  :close-on-select="false"
                                  placeholder="Select Prescription"
                                  @input="FilterBySelectedItem($event, 'prescription')"
                                >
                                </multiselect>
   
               
                  
                 </div>
                
                                <div class="col-2 ">
                                   <a                                                    
                                                    @click.prevent="
                                                      openprescriptionpopup(
                                                        true
                                                      )
                                                    "
                                                    href="javascript:void(0);"
                                                    title="Add Prescription"
                                                    class="add-prescription"
                                                    data-toggle="modal"
                                                    data-target="#myModal1"
                                                  >
                                                  <i class="material-icons" style="position: relative; top: 6px; font-size: 20px;">add</i>
                                                    <!-- <i
                                                      class="material-icons"
                                                      style="color: #262626"
                                                      >note_add</i
                                                    > -->
                                                  </a>
                                  <!-- <a href="javascript:void(0)" @click.prevent="openprescriptionpopup(true)" class=" secondary-btn ripple pull-right  " style="min-width: auto;"><i class="material-icons" style="position: relative; top: 6px; font-size: 20px;">add</i></a> -->
                                  </div>
                
                             <div>     
                             
                            </div>
                            <div class="col-12">
                              <p>
  <a class="suggestion_acc" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
  Choose From Suggestions<i class="material-icons">keyboard_arrow_down</i>
  </a>
</p>
<div class="collapse" id="collapseExample">
  <div class="col-12 pb-3" id="cho_Sugge">              
                              
                                
                                <div v-if="!suggested_summaries_list.length==0" style="max-height: 300px; overflow-y: auto">
                                  <table class="table table-striped table-sm m-0">
                                    <tbody>
                                      <tr v-for="(summary, index ) in suggested_summaries_list" :key="index">
                                        <td>
                                          <span><b>Suggested Summary -&nbsp;{{ index + 1 }}</b></span>
                                          <!-- <button type="button" v-on:click="CopySummary(index)" class="btn btn-outline-danger btn-sm">
                                            Copy Summary
                                          </button> -->
                                          <div>
                                            <div  :id="'suggested_summary_line_' + index +'_' +line_index"
                                             :class="{ 'line-selected': isLineSelected(index, line_index),'line-unselected': !isLineSelected(index, line_index) }"
                                              @click="UseLine(index, line_index)"
                                              v-for="(line, line_index) in summary"
                                              :key="line_index"
                                            >
                                              <span>{{ line }}</span>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!-- <div v-else>
                                    <p>No Suggestions Found</p>
                                </div> -->
                              
                             </div>
</div>
                            </div>
                           
                             <!-- <div class="col-12">
                                <li class="card parent">
                                                    <h5 data-toggle="collapse"   href="#pre-visit-drop"   class="hover-effect white menu-title arrow-wd collapsed" ><span   class="provider-integration-settings toggle-menu toggle-menu-1"  data-placement="left"></span>Previous Summaries</h5>
                                                     <div id="pre-visit-drop" class="ul-hold wrapper collapse" >
                                                            <div id="Previous_sum" v-if="previous_summary.length!=0" class="col-12">
                                                                                  <ul class="previouslist p-0 m-0 nav nav-tabs text-center " id="myTab" role="tablist" style="background:#1870c9;">
                            <a href="javascript:void(0)" class="table_left-btn"><i class="material-icons">keyboard_arrow_left</i></a>
                            <li class="nav-item " :class="[index==0?'active':'']" v-for="(data, index) in previous_summary" :key="index">
                              <a style="font-size:12px;" class="nav-link" :class="[index==0?'active':'']" :id="'tab-'+index" data-toggle="tab" :href="'#previous_summary-'+index" role="tab" :aria-controls="'previous_summary-'+index" :aria-selected="[index==0?'true':false]">{{getFormattedDate(data.visit_date)}}</a>
                              <a href="javascript:void(0);" data-toggle="modal" title="View" data-target="#previousSumHold" class="action-view"  ></a>
                            </li>
                            
                            <a href="javascript:void(0)" class="table_right-btn" ><i class="material-icons" >keyboard_arrow_right</i ></a>
                      </ul>
 <div class="btnhold">
   <span><a href="#" class="view-more">View more</a>
   </span>
</div>
                                                            </div>
                                                     </div>                                                    
                                                </li>
                             </div> -->

              </div>        
            </div>
           
         </div>
       </div>
    </div>    
     <CreatePrescription
                                ref="createPrescriptionRef"
                                :prescriptionobj="ViewPrecriptionData"
                                @redirecttoprescription="openprescriptionpopup"
                                @closepopup="onclosepopup"
                              >
                              </CreatePrescription>
 </div>
   
       
                
          
    
  
</template>

<script>
import Axios from "axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import Auth from "@/common/mixins";
import CreatePrescription from "@/components/Prescription/createprescription";
// import LeftMenuPatientInfo from "@/components/Navmenu/LeftMenuPatientInfo.vue"

export default {
  mixins: [Auth],
  components: {
    Multiselect,
    CreatePrescription,   
  },
  updated() {
    $(document).ready(function () {
      $(".suggestedContent").click(function () {
        $(this).css({ color: "black", "text-decoration": "none" });
        $(this).removeAttr("data-suggestion");
      });

      $("#selectedvalue").click(function () {
        $(".days").slideToggle();
      });

      $(".days li").click(function () {
        $("#selectedvalue").text($(this).attr("value"));
        $(".days").slideUp();
      });
    });
  },
  mounted() {
     if(localStorage.getItem("Machinelearning") == "true"){
      this.showML = false;
    }
    else{
       this.showML = true;
    }
    if(sessionStorage.Prescriptionbyencounter && JSON.parse(sessionStorage.Prescriptionbyencounter).prescription_details
     && JSON.parse(sessionStorage.Prescriptionbyencounter).prescription_details.length>0){
       this.addprescriptiondata();
     }

    this.getPreviousSummary();
    this.FilterBySelectedItem();
  },
  watch: {},
  data() {
    return {
      suggested_summaries_list: [],

      previous_summary: [],

      selected_diagnosis_list: [],
      selected_symptoms_list: [],
      selected_comorbidities_list: [],
      selected_investigation_list: [],
      selected_radiology_list: [],
      selected_supportive_treatment_list: [],
      selected_prescription_list: [],
      selected_lines_list:[],

      diagnosis_list: [],
      symptoms_list: [],
      comorbidities_list: [],
      investigation_list: [],
      radiology_list: [],
      supportive_treatment_list: [],
      prescription_list: [],
      customer_id: localStorage.selectedPatientId,
      tenant_id: localStorage.tenantid,
      provider_id: JSON.parse(localStorage.loggedInUserInfo).unique_id,
      accessToken: localStorage.accesstoken,
      API_URL: process.env.VUE_APP_PYTHON_API_URL,
      showML:true,
      showprescriptionpopup: false,
      ViewPrecriptionData: {},

    };
  },

  created() {   
    $(function () {
      $(".table_left-btn").click(function () {
        $(this).parent(".previouslist").animate({ scrollLeft: "-=100" }, 400);
      });
      $(".table_right-btn").click(function () {
        $(this).parent(".previouslist").animate({ scrollLeft: "+=100" }, 400);
      });
    });
    $(document).ready(function () {
      $("body").addClass("menu-toggled-body");
      var headerhold = document.getElementById("headerholds");
      var headerholdsmall = document.getElementById("headerholdsmalls");

      if (
        headerholdsmall &&
        headerholdsmall.classList.contains("header-logohide")
      ) {
        var addclass = document.getElementById("headerholds");
        addclass = addclass.classList.add("header-logohide");
        var addclasssmall = document.getElementById("headerholdsmalls");
        addclasssmall = addclasssmall.classList.remove("header-logohide");
      }
      $(".headerhold-small").show();
      $(".headerhold").hide();
    });
  },

  methods: {
    AddFrequentDataOnTop(type, arr){
if(type=='symptom'){
  const symptomsFilteredArray = this.symptoms_list.filter(value => !arr.includes(value));
  this.symptoms_list = []
  this.symptoms_list = [...arr, ...symptomsFilteredArray]
}
if(type=='diagnosis'){
  const diagnosisFilteredArray = this.diagnosis_list.filter(value => !arr.includes(value));
  this.diagnosis_list = []
  this.diagnosis_list = [...arr, ...diagnosisFilteredArray];
}
if(type=='comorbidity'){
  const comorbidityFilteredArray = this.comorbidities_list.filter(value => !arr.includes(value));
  this.comorbidities_list = []
  this.comorbidities_list = [...arr,...comorbidityFilteredArray];
}
if(type=='investigation'){
  const investigationFilteredArray = this.investigation_list.filter(value => !arr.includes(value));
  this.investigation_list = []
  this.investigation_list = [...arr,...investigationFilteredArray];
}
if(type=='radiology'){
  const radiologyFilteredArray = this.radiology_list.filter(value => !arr.includes(value));
  this.radiology_list = [];
  this.radiology_list = [...arr, ...radiologyFilteredArray];
}
if(type=='supportive_treatment'){
  const supportive_treatmentFilteredArray = this.supportive_treatment_list.filter(value => !arr.includes(value));
  this.supportive_treatment_list = []
  this.supportive_treatment_list = [...arr,...supportive_treatmentFilteredArray];
}
if(type=='prescription'){
  const prescriptionFilteredArray = this.prescription_list.filter(value => !arr.includes(value));
  this.prescription_list = []
  this.prescription_list = [...arr,...prescriptionFilteredArray];
}
    },

    SaveMLSummary(){
        let buildHTML = `<div id="mlsummarycontent">`
        

        if (this.selected_symptoms_list.length != 0){
            buildHTML += `<p>Symptoms: ${this.selected_symptoms_list.join(", ")}</p>`
        }
        if (this.selected_diagnosis_list.length != 0){
            buildHTML += `<p>Diagnosis: ${this.selected_diagnosis_list.join(", ")}</p>`
        }
        if (this.selected_comorbidities_list.length != 0){
            buildHTML += `<p>Comorbidity: ${this.selected_comorbidities_list.join(", ")}</p>`
        }
        if (this.selected_investigation_list.length != 0){
            buildHTML += `<p>Investigation: ${this.selected_investigation_list.join(", ")}</p>`
        }
        if (this.selected_radiology_list.length != 0){
            buildHTML += `<p>Radiology: ${this.selected_radiology_list.join(", ")}</p>`
        }
        if (this.selected_supportive_treatment_list.length != 0){
            buildHTML += `<p>Supportive Treatment: ${this.selected_supportive_treatment_list.join(", ")}</p>`
        }
        if (this.selected_prescription_list.length != 0){
            buildHTML += `<p>Prescription: ${this.selected_prescription_list.join(", ")}</p>`
        }
        if (this.selected_lines_list.length != 0){
            for(let i=0; i<this.selected_lines_list.length; i++){
              buildHTML += `<p>${this.selected_lines_list[i]}</p><br/>`
            }
            // buildHTML += `<p>${this.selected_lines_list}</p>`
        }
        buildHTML += `</div>`
        buildHTML += `<br/>`

        let MLPropObj = {};
        MLPropObj.selected_symptoms_list = this.selected_symptoms_list;
        MLPropObj.selected_diagnosis_list = this.selected_diagnosis_list;
        MLPropObj.selected_comorbidities_list = this.selected_comorbidities_list;
        MLPropObj.selected_investigation_list = this.selected_investigation_list;
        MLPropObj.selected_radiology_list = this.selected_radiology_list;
        MLPropObj.selected_supportive_treatment_list = this.selected_supportive_treatment_list;
        MLPropObj.selected_prescription_list = this.selected_prescription_list;

        this.$emit("BuildMLSummary", {buildHTML, MLPropObj});
    },

    ClearMLPopUp(){
      // clearnig v-model(this vue file) 
      this.selected_symptoms_list = [];
      this.selected_diagnosis_list = [];
      this.selected_comorbidities_list = [];
      this.selected_investigation_list = [];
      this.selected_supportive_treatment_list = [];
      this.selected_radiology_list = [];
      this.selected_prescription_list = [];
      this.selected_lines_list = [];
      this.FilterBySelectedItem();
    },
    onclosepopup(){
      if(sessionStorage.Prescriptionbyencounter && JSON.parse(sessionStorage.Prescriptionbyencounter).prescription_details
     && JSON.parse(sessionStorage.Prescriptionbyencounter).prescription_details.length>0){
       this.addprescriptiondata();
     } 
    },
    addprescriptiondata(){
      var presciption_list = "";
      presciption_list =  JSON.parse(sessionStorage.Prescriptionbyencounter).prescription_details;
      for(var i=0;i<presciption_list.length;i++){
        var count =0;
        var no_of_drugs = 0;
        var drug_string = "";
        if(presciption_list[i].drug_details.CIMSDESC != undefined){
          drug_string = presciption_list[i].drug_details.CIMSDESC;
        }
        else{
          drug_string = presciption_list[i].drug_details;
        }
        if(this.selected_prescription_list.length >0){
          for(var j =0;j<this.selected_prescription_list.length;j++){
            if(drug_string ==(this.selected_prescription_list[j].split('-')[0])){
            this.selected_prescription_list.splice(j,1);
            }
          }
        }
        drug_string += '-'+ presciption_list[i].strength_units;
        drug_string += '-'+ presciption_list[i].course_period;        
        if(presciption_list[i].direction_afternoon == true)
        {
          count ++;
        }
        if(presciption_list[i].direction_evening == true)
        {
          count ++;
        }
        if(presciption_list[i].direction_morning == true)
        {
          count ++;
        }
        if(presciption_list[i].direction_night == true)
        {
          count ++;
        }
        drug_string += '-'+ count;
        no_of_drugs =  Number(presciption_list[i].course_period) * count;
        drug_string += '-'+ no_of_drugs;
        var drug_string_data = [];
        drug_string_data[i] = drug_string;
        // this.selected_prescription_list.push(drug_string_data[i]);
        this.addKeyword(drug_string_data[i],'prescription');
        // this.FilterBySelectedItem("s", 'prescription');
       // alert(drug_string);
      }
    },
    removeKeyword(word, type){
        if (this.symptoms_list.includes(word) ||
            this.comorbidities_list.includes(word) ||
            this.diagnosis_list.includes(word) ||
            this.prescription_list.includes(word) ||
            this.investigation_list.includes(word) ||
            this.radiology_list.includes(word) ||
            this.supportive_treatment_list.includes(word)
            ){
          console.error("word present in list, no need to remove from db")
        }
        else{
          console.error("This word is from db, delete from there.")
          var req_data = {};
          req_data.word = word;
          req_data.speciality_name = JSON.parse(localStorage.loggedInUserInfo).category_list[0].category
          req_data.provider_id = this.provider_id;
          req_data.tenant_id = this.tenant_id;
          req_data.type = type;
          Axios.request({
            method: "delete",
            url: this.API_URL + "/v2/remove_keyword",
            data: req_data,
            headers: {Authorization: this.accessToken},
          })
            .then((res) => {
              var status = res.data.status
            })
            .catch((err) => {
              console.log("Error: ", err);
            });
        }
    },
    openprescriptionpopup(redirecttoprescription) {
      if (redirecttoprescription == true) {
        this.onCreatePrescriptions();       
      }
    },
    onCreatePrescriptions: function() {
      if (Auth.checkAuthentication()) {
        this.showauthenticationcheck = false;
        this.ViewPrecriptionData = {};
        var enc_id = this.$route.query.range_key;
        var enc_unique_id = enc_id.split("_");
        var cust_id = enc_unique_id[0];
        var apoo_id = enc_unique_id[1];
        this.ViewPrecriptionData.provider_id = this.provider_id;
        this.ViewPrecriptionData.created_date = localStorage.encounterdate;
        this.ViewPrecriptionData.appointment_id = apoo_id;
        this.ViewPrecriptionData.encounter_id =enc_id;
        this.ViewPrecriptionData.customer_id = this.customer_id;
        this.ViewPrecriptionData.tenantId = this.tenant_id;
        this.ViewPrecriptionData.patient_encounter_number = "";
        var prescriptionlist = [];
        if(sessionStorage.Prescriptionbyencounter)
        {
          prescriptionlist = JSON.parse(sessionStorage.Prescriptionbyencounter);
        }
        else{
          prescriptionlist = [];
        }
        this.ViewPrecriptionData.predetails = prescriptionlist;
        this.ViewPrecriptionData.iframeid = "iframeencounter";
        if(this.$refs.createPrescriptionRef && this.$refs.createPrescriptionRef.prescriptiondetails && typeof this.$refs.createPrescriptionRef.prescriptiondetails==="function")
        {
          this.$refs.createPrescriptionRef.prescriptiondetails();
        }
        this.showprescriptionpopup = true;
      } else {
        this.showauthenticationcheck = true;
      }       
    },
    closepopup(element){
      alert("check data");
    },
    addKeyword(word,type){
      console.error("add keywrd called.");
      word = word.trim();
      var req_data = {};
      req_data.speciality_name = JSON.parse(localStorage.loggedInUserInfo).category_list[0].category
      req_data.provider_id = this.provider_id;
      req_data.tenant_id = this.tenant_id;
      req_data.type = type;
      if (type==='symptom'){
        this.selected_symptoms_list.push(word);
        this.$emit("SelectedSymptoms", this.selected_symptoms_list);  
        req_data.word = word.trim();      
      }
      else if(type==='diagnosis'){
        this.selected_diagnosis_list.push(word);
        this.$emit("SelectedDiagnosis", this.selected_diagnosis_list); 
        req_data.word = word;      
      }
      else if(type==='comorbidity'){
        this.selected_comorbidities_list.push(word);
        this.$emit("SelectedComorbidity", this.selected_comorbidities_list); 
        req_data.word = word;      
      }
      else if(type==='investigation'){
        this.selected_investigation_list.push(word);
        this.$emit("SelectedInvestigation", this.selected_investigation_list);
        req_data.word = word;      
      }
      else if(type==='radiology'){
        this.selected_radiology_list.push(word);
        this.$emit("SelectedRadiology", this.selected_radiology_list);
        req_data.word = word;      
      }
      else if(type==='supportive_treatment'){
        this.selected_supportive_treatment_list.push(word);
        this.$emit("SelectedSupportiveTreatment", this.selected_supportive_treatment_list);
        req_data.word = word;      
      }
      else if(type==='prescription'){
        this.selected_prescription_list.push(word);
        this.$emit("SelectedPrescription", this.selected_prescription_list);
        req_data.word = word;      
      }

      Axios.request({
        method: "post",
        url: this.API_URL + "/v2/add_keyword",
        data: req_data,
        headers: {Authorization: this.accessToken},
      })
        .then((res) => {
          var status = res.data.status
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },

    // addDiagnosis(word){
    //   this.selected_diagnosis_list.push(word);
    //   this.$emit("SelectedDiagnosis", this.selected_diagnosis_list);
      
    //   var req_data = {};
    //   req_data.speciality_name = JSON.parse(localStorage.loggedInUserInfo).category_list[0].category
    //   req_data.diagnosis = word;
    //   req_data.provider_id = this.provider_id;
    //   req_data.tenant_id = this.tenant_id;

    //   Axios.request({
    //     method: "post",
    //     url: this.API_URL + "/add_diagnosis",
    //     data: req_data,
    //     headers: {Authorization: this.accessToken},
    //   })
    //     .then((res) => {
    //       var status = res.data.status
    //     })
    //     .catch((err) => {
    //       console.log("Error: ", err);
    //     })
    // },

    // addComorbidity(word){
    //   this.selected_comorbidities_list.push(word);
    //   this.$emit("SelectedComorbidity", this.selected_symptoms_list);
      
    //   var req_data = {};
    //   req_data.speciality_name = JSON.parse(localStorage.loggedInUserInfo).category_list[0].category
    //   req_data.comorbidity = word;
    //   req_data.provider_id = this.provider_id;
    //   req_data.tenant_id = this.tenant_id;

    //   Axios.request({
    //     method: "post",
    //     url: this.API_URL + "/add_comorbidity",
    //     data: req_data,
    //     headers: {Authorization: this.accessToken},
    //   })
    //     .then((res) => {
    //       var status = res.data.status
    //     })
    //     .catch((err) => {
    //       console.log("Error: ", err);
    //     })
    // },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    // UseLine(id){
    //   debugger;
    //   if( !$("#"+id).hasClass("line-selected")){
    //     var self = this;
    //     $("#" + id).css("color", "black");
    //     $("#" + id).addClass("line-selected");
    //     // this.$emit("SelectedLine", $('#'+id).text());
    //     let line = $('#'+id).text();
    //     self.selected_lines_list.push(line);
    //   }
    // },
    UseLine(index, line_index) {
    const lineId = `${index}_${line_index}`;
    const lineText = this.suggested_summaries_list[index][line_index];

    if (!this.selected_lines_list.includes(lineText)) {
      this.selected_lines_list.push(lineText);
    } else {
      // Remove line if already selected (toggle)
      this.selected_lines_list = this.selected_lines_list.filter(line => line !== lineText);
    }
  },
  isLineSelected(index, line_index) {
    const lineText = this.suggested_summaries_list[index][line_index];
    return this.selected_lines_list.includes(lineText);
  },

    CopySummary(index) {
      var selected_summary = this.suggested_summaries_list[index];
      var suggestions = '';
      for (var i = 0; i < selected_summary.length; i++) {
        suggestions+=selected_summary[i]+"\n";
      }
      this.$emit("SelectedSummary", suggestions)
    },
    
    FilterBySelectedItem: function (e, component) {
      var req_data = {};
      req_data.provider_id = this.provider_id;
      req_data.tenant_id = this.tenant_id;

      req_data.selected_diagnosis_list = this.selected_diagnosis_list;
      req_data.selected_symptoms_list = this.selected_symptoms_list;
      req_data.selected_comorbidities_list = this.selected_comorbidities_list;
      req_data.selected_investigation_list = this.selected_investigation_list;
      req_data.selected_radiology_list = this.selected_radiology_list;
      req_data.selected_supportive_treatment_list = this.selected_supportive_treatment_list;
      req_data.selected_prescription_list = this.selected_prescription_list;
      Axios.request({
        method: "post",
        url: this.API_URL + "/v2/get_filtered_data",
        data: req_data,
        headers: {Authorization: this.accessToken},
      })
        .then((res) => {
          this.AddFrequentDataOnTop('symptom',res.data.symptoms_list);
          this.AddFrequentDataOnTop('diagnosis',res.data.diagnosis_list);
          this.AddFrequentDataOnTop('comorbidity',res.data.comorbidities_list);
          this.AddFrequentDataOnTop('investigation',res.data.investigation_list);
          this.AddFrequentDataOnTop('radiology',res.data.radiology_list);
          this.AddFrequentDataOnTop('supportive_treatment',res.data.supportive_treatment_list);
          this.AddFrequentDataOnTop('prescription',res.data.prescription_list);
          this.suggested_summaries_list = res.data.suggested_summaries;

          // this.comorbidities_list = res.data.comorbidities_list;
          // this.diagnosis_list = res.data.diagnosis_list;
          // this.symptoms_list = res.data.symptoms_list;
          // this.comorbidities_list = res.data.comorbidities_list;
          // this.investigation_list = res.data.investigation_list;
          // this.radiology_list = res.data.radiology_list;
          // this.supportive_treatment_list = res.data.supportive_treatment_list;
          // this.prescription_list = res.data.prescription_list;

        })
        .catch((err) => {
          console.log("Error: ", err);
        }).finally(()=>{
          // if (component==='symptoms'){this.$emit("SelectedSymptoms", this.selected_symptoms_list);}
          // else if(component==='supportive_treatment'){this.$emit("SelectedSupportiveTreatment", this.selected_supportive_treatment_list);}
          // else if(component==='comorbidity'){this.$emit("SelectedComorbidity", this.selected_comorbidities_list);}
          // else if(component==='diagnosis'){this.$emit("SelectedDiagnosis", this.selected_diagnosis_list);}
          // else if(component==='investigation'){this.$emit("SelectedInvestigation", this.selected_investigation_list);}
          // else if(component==='radiology'){this.$emit("SelectedRadiology", this.selected_radiology_list);}
          // else if(component==='prescription'){this.$emit("SelectedPrescription", this.selected_prescription_list);}
        });

    },
    getPreviousSummary() {
      var req_data = {};
      
      req_data.customer_id = this.customer_id;
      req_data.provider_id = this.provider_id;
      req_data.tenant_id = this.tenant_id;
      Axios.request({
        method: "post",
        url: this.API_URL + "/v2/get_provider_frequent_data",
        data: req_data,
        headers: {Authorization: this.accessToken},
      })
        .then((res) => {
          this.previous_summary = res.data.previous_summary;
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
 
  },
};
</script>

 <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style > 
#MlListpopup .modal-dialog .modal-content{min-height: 585px;}
.modal-body .multiselect__input{border:none !important;}
.modal-body .multiselect__option--highlight, .multiselect__option.multiselect__option--highlight, .multiselect__option--highlight:after{background: #0056e0;}
.modal-body .multiselect__tag{background: #0056e0;}
.modal-body .multiselect__tag-icon:after {    font-size: 24px;    font-weight: 100;    color: #fff;}
.multiselect__tags{    border-radius: 10px;border: 1px solid #c9cbce;    min-height: 50px;    padding-top: 12px;}
.multiselect__placeholder{color:#898386;}
.multiselect__select:after {
  position: absolute;
  top: 13px;
  right: 10px;
  width: 20px;
  height: 20px;
  padding: 4px;
  content: "";
  pointer-events: none;
  background: #ffffff url(../../static/images/arrow-down.png) 0px 0px no-repeat;
}
.sidenav-hold .card .pastrecord.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -14px -14px no-repeat;}
.sidenav-hold .card .record-data-visit.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -14px -130px no-repeat;}
.sidenav-hold .card .machineLearning.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -19px -191px no-repeat;}
.sidenav-hold .card .PreviousSummarie.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -14px -75px no-repeat;}
.sidenav-hold .card .standardEHR.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -16px -247px no-repeat;}
.sidenav-hold .card .referred-patients.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.03e975fe_New.png)-19px -304px  no-repeat;}

.sidenav-hold .card .menu-title:hover .referred-patients.toggle-menu:after, .sidenav-hold .card .menu-title.active .referred-patients.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.03e975fe_New.png) -80px -304px no-repeat;}

.sidenav-hold .card .menu-title:hover .pastrecord.toggle-menu:after, .sidenav-hold .card .menu-title.active .pastrecord.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -75px -14px no-repeat;}
.sidenav-hold .card .menu-title:hover .record-data-visit.toggle-menu:after, .sidenav-hold .card .menu-title.active .record-data-visit.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -76px -130px no-repeat;}
.sidenav-hold .card .menu-title:hover .machineLearning.toggle-menu:after, .sidenav-hold .card .menu-title.active .machineLearning.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -75px -191px no-repeat;}
.sidenav-hold .card .menu-title:hover .PreviousSummarie.toggle-menu:after, .sidenav-hold .card .menu-title.active .PreviousSummarie.toggle-menu:after{ background:url(../../static/images/ML-sprite-icons.png) -75px -75px no-repeat;}
.sidenav-hold .card .menu-title.active .standardEHR.toggle-menu:after, .sidenav-hold .card .menu-title .standardEHR.toggle-menu:after{    left: -6px;
    position: relative;}
.text-info {    color: #0056e0;    background: #f2ebeb;    text-align: center;    padding: 8px;    font-size: 15px;    border: 1px solid #dcd7d7;}
.suggestion_acc{color: #0a0a0a;
    font-size: 15px;
    display: inline-block;
    width: auto;}
    .suggestion_acc i{transition: all 0.5s ease-in-out;
    transform: rotate(180deg);position: relative;font-size: 28px; top: 9px;  color: #0056e0;    margin: 0 3px;}
    .suggestion_acc.collapsed i{color: #0056e0; 
    transition: all 0.5s ease-in-out;
    transform: rotate(0deg);}
  #MlListpopupContent .text-info {    color: #0056e0 !important;    background: #f2ebeb;    text-align: center;    padding: 8px;    font-size: 15px;    border: 1px solid #dcd7d7;}
.add-prescription, .add-prescription:focus, .add-prescription{background: #0056e0;color: #fff !important;padding: 3px;position:relative;top: 35px;}
   .table-striped tbody tr:first-child{border-radius:10px 10px 0 0 ;}
    .table-striped tbody tr:last-child{border-radius:10px 10px 0 0 ;}
   #sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 90%;
  display: inline-block;
  justify-content: center;
  align-items: center;
  background: #fff;
  z-index: 1;
  margin-right: 20px;height:0;
}
.line-selected {
  color: black;
}

.line-unselected {
  color: grey; /* Default color for unselected lines */
}
#MlListpopupContent .multiselect--above .multiselect__content-wrapper, #MlListpopupContent .multiselect--active .multiselect__content-wrapper {
    top: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-top: none;
    border-bottom: 1px solid #e8e8e8;bottom: auto !important;}
    #MlListpopupContent #Prescriptionhold .multiselect__content-wrapper{max-height:130px !important;}
    
</style>